import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  myLearningTab: {
    id: 'courses.tabs.myLearning',
    defaultMessage: 'My Learning',
    description: 'Label for the enrollments tab listing all enrolled courses, programs and learning paths',
  },
  coursesTab: {
    id: 'courses.tabs.courses',
    defaultMessage: 'Courses',
    description: 'Label for the Courses tab on the courses page',
  },
  coursesAndProgramsTab: {
    id: 'courses.tabs.coursesAndPrograms',
    defaultMessage: 'Courses & Programs',
    description: 'Label for the enrollments tab when the learner is enrolled in at least one course and one program',
  },
  programsTab: {
    id: 'courses.tabs.programs',
    defaultMessage: 'Programs',
    description: 'Label for the enrollments tab when the learner is enrolled only in programs (no standalone courses)',
  },
  notesTab: {
    id: 'courses.tabs.notes',
    defaultMessage: 'Notes',
    description: 'Label for the Notes tab on the courses page',
  },
  goToLesson: {
    id: 'courses.notes.goToLesson',
    defaultMessage: 'Go to Lesson',
    description: 'Link text that navigates the learner to the lesson related to a note',
  },
  fromLessonLabel: {
    id: 'courses.notes.fromLessonLabel',
    defaultMessage: 'From Lesson:',
    description: 'Label preceding the lesson excerpt for a selected note',
  },
  yourNoteLabel: {
    id: 'courses.notes.yourNoteLabel',
    defaultMessage: 'Your Note:',
    description: 'Label preceding the learner-authored note text',
  },
  noNotesYet: {
    id: 'courses.notes.empty.title',
    defaultMessage: 'No notes yet!',
    description: 'Empty state heading shown when the learner has not created any notes',
  },
  noNotesDescription: {
    id: 'courses.notes.empty.description',
    defaultMessage: 'Enroll in a course to start capturing key points.',
    description: 'Empty state description shown when the learner has no notes',
  },
  notesHeading: {
    id: 'courses.notes.heading',
    defaultMessage: 'Notes',
    description: 'Heading for the notes list section on the courses page',
  },
  sortByLabel: {
    id: 'courses.notes.sortByLabel',
    defaultMessage: 'Sort by:',
    description: 'Label for the notes sort dropdown',
  },
  sortLatest: {
    id: 'courses.notes.sortLatest',
    defaultMessage: 'Latest',
    description: 'Sort option that orders notes from newest to oldest',
  },
  sortOldest: {
    id: 'courses.notes.sortOldest',
    defaultMessage: 'Oldest',
    description: 'Sort option that orders notes from oldest to newest',
  },
  showMoreNotes: {
    id: 'courses.notes.showMore',
    defaultMessage: 'Show more Notes',
    description: 'Button label to load more notes in the list',
  },
  noteCreatedAt: {
    id: 'courses.notes.createdAt',
    defaultMessage: 'Created {date}',
    description: 'Metadata line showing when a note was created',
  },
  noteLastEdited: {
    id: 'courses.notes.lastEdited',
    defaultMessage: 'Last edited {date}',
    description: 'Metadata line showing when a note was last edited',
  },
  notesLoading: {
    id: 'courses.notes.loading',
    defaultMessage: 'Loading notes',
    description: 'Screen reader text shown while the notes list is loading',
  },
  enrollmentCoursesTitle: {
    id: 'courses.enrollments.coursesTitle',
    defaultMessage: 'Courses',
    description: 'Section heading for the enrolled courses grid',
  },
  enrollmentProgramsTitle: {
    id: 'courses.enrollments.programsTitle',
    defaultMessage: 'Programs',
    description: 'Section heading for the enrolled programs grid',
  },
  fallbackCourseTitle: {
    id: 'courses.enrollments.fallbackCourseTitle',
    defaultMessage: 'Course',
    description: 'Fallback title shown on an enrolled course card when no course name is available',
  },
  fallbackProgramTitle: {
    id: 'courses.enrollments.fallbackProgramTitle',
    defaultMessage: 'Program',
    description: 'Fallback title shown on an enrolled program card when no program name is available',
  },
  courseBadge: {
    id: 'courses.enrollments.courseBadge',
    defaultMessage: 'Course',
    description: 'Badge label shown on an enrolled course card',
  },
  programBadge: {
    id: 'courses.enrollments.programBadge',
    defaultMessage: 'Program',
    description: 'Badge label shown on an enrolled program card',
  },
  enrollmentPathwaysTitle: {
    id: 'courses.enrollments.pathwaysTitle',
    defaultMessage: 'Learning paths',
    description: 'Section heading for the enrolled learning paths grid',
  },
  fallbackPathwayTitle: {
    id: 'courses.enrollments.fallbackPathwayTitle',
    defaultMessage: 'Learning path',
    description: 'Fallback title shown on an enrolled pathway card when no name is available',
  },
  pathwayBadge: {
    id: 'courses.enrollments.pathwayBadge',
    defaultMessage: 'Learning path',
    description: 'Badge label shown on an enrolled pathway card',
  },
  courseStartsInDays: {
    id: 'courses.enrollments.startsInDays',
    defaultMessage: 'Course starts in {days, plural, one {# day} other {# days}} on {date}.',
    description: 'Toast message shown when learner clicks a locked course that starts in the future',
  },
  courseStartsOn: {
    id: 'courses.enrollments.startsOn',
    defaultMessage: 'Course starts on {date}.',
    description: 'Toast message shown when learner clicks a locked course with a known start date',
  },
  courseHasNotStarted: {
    id: 'courses.enrollments.hasNotStarted',
    defaultMessage: 'Course has not started yet.',
    description: 'Toast message shown when learner clicks a locked course with no known start date',
  },
  addCalendarReminder: {
    id: 'courses.enrollments.addCalendarReminder',
    defaultMessage: "Don't forget to add a calendar reminder!",
    description: 'Hint shown alongside the locked course start-date toast',
  },
});

export default messages;
